import { AxiosRequestConfig, AxiosResponse } from 'axios';

import GetPaginatedResponse from '../../../../Api/CRM/Responses/PaginatedResponse';

import {
    API_CASINO_SESSION_BETS,
    API_CASINO_SESSIONS,
    API_CASINO_TRANSACTIONS_FOR_USER,
} from '../../../../crm/casino/pages/Helpers/CrmApiUrls';
import AbstractCasinoCRMApi from '../../AbstractCasinoCRMApi';
import CasinoGameSessions from '../../Models/CasinoGameSessions';
import CasinoTransaction from '../../Models/CasinoTransaction';
import GetCasinoGameSessions from '../Responses/CasinoGameSessions';
import GetCasinoTransactionResponse from '../Responses/CasinoTransactionResponse';

class CasinoTransactionsApi extends AbstractCasinoCRMApi {
    public getPaginatedBySessionId(
        page: number = 1,
        sessionId: string | number,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<CasinoTransaction>> {
        return this.get(API_CASINO_SESSION_BETS, {
            ...config,
            params: { ...config?.params, page, sessionId },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetCasinoTransactionResponse>>) => {
            return AbstractCasinoCRMApi.mapPaginatedDataToModel(response.data, CasinoTransaction);
        });
    }
    public getPaginatedSessions(
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<CasinoGameSessions>> {
        return this.get(API_CASINO_SESSIONS, { ...config, params: { ...config.params, page } }).then(
            (response: AxiosResponse<GetPaginatedResponse<GetCasinoGameSessions>>) => {
                return AbstractCasinoCRMApi.mapPaginatedDataToModel(response.data, CasinoGameSessions);
            }
        );
    }

    public getPaginatedByUserId(
        page: number = 1,
        userId: number,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<CasinoTransaction>> {
        return this.get(API_CASINO_TRANSACTIONS_FOR_USER, {
            ...config,
            params: { ...config.params, page, userId },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetCasinoTransactionResponse>>) => {
            return AbstractCasinoCRMApi.mapPaginatedDataToModel(response.data, CasinoTransaction);
        });
    }
}

export default new CasinoTransactionsApi();
